import React, { FC } from 'react';
import TimeAgo from 'react-timeago';
import { useTranslation } from 'react-i18next';
import { CommonNS } from '../../translation-namespaces';

interface DateComponentProps {
    date: string | undefined;
    showFull?: boolean;
}

const DateComponent: FC<DateComponentProps> = (props) => {
    const { date, showFull } = props;
    const twoDays = 48 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds

    const { t } = useTranslation([CommonNS]);

    const dateTime = date ? new Date(date) : new Date();
    const [oldDateThreshold] = React.useState(new Date().getTime() - twoDays);

    if (!date) {
        return null;
    }

    return dateTime < new Date(oldDateThreshold) || showFull ? (
        <span title={`${t('datetime2', { date: dateTime })}`} data-testid="DateComponent">
            {showFull && t('datetime', {
                date: dateTime,
            })}
            {!showFull && t('date', { date: dateTime })}
        </span>
    ) : (
        <TimeAgo
            date={date}
            title={`${t('datetime2', { date: dateTime })}`}
        />
    );
};

export default DateComponent;

DateComponent.defaultProps = {
    showFull: false,
};
